/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TimelineHistory from '../../../../../../../../components/ui-elements/timeline/TimelineHistory';
import { Typography } from '@mui/material';
import { useState } from 'react';
import { getAppUserHistory } from '../../../../../../../../store/reducers/applicationUsers/applicationUsersAction';

const OrgAppUserHistory = ({ selectedOrgAppUser }) => {
    const [historyList, setHistoryList] = useState([]);
    const orgAppUserHistory = useSelector(state => state.applicationUsers.orgAppUserHistory)
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getAppUserHistory({ organizationApplicationUserID: selectedOrgAppUser.organizationApplicationUserID }))

    }, [dispatch, selectedOrgAppUser]);

    useEffect(() => {
        setHistoryList([]);
        if (orgAppUserHistory?.length > 0) {
            orgAppUserHistory.forEach(element => {
                setHistoryList(item => [...item, {
                    ...element, Record: {
                        name: element.Record.organizationApplicationUserName,
                        details: element.Record.organizationApplicationUserDetails,
                        createdBy: element.Record.createdBy ?? "",
                        updatedBy: element.Record.updatedBy ?? "",
                    }
                }]);
            });
        }
    }, [orgAppUserHistory]);
    return (
        <>
            <Typography variant="h3" align="center" color="success.light"> History</Typography>
            <TimelineHistory items={historyList} />
        </>
    )

}



export default OrgAppUserHistory;